import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchStyles } from "../../../../store/slices/servicesSlice";
import { getImageUrl } from "../../../../utils/commonFunctions";
import { Image } from "primereact/image";

export default function StyleGuide() {
  const dispatch = useDispatch();

  let { furnishingStyles } = useSelector((state) => state.service);
  useEffect(() => {
    dispatch(fetchStyles());
  }, [dispatch]);

  return (
    <div className="container">
      <div className="md:flex justify-content-between gap-3">
        <h2 className="text-3xl">Style Guide</h2>
      </div>
      <hr />
      <div className="flex flex-wrap gap-3 py-2 justify-content-center">
        {furnishingStyles.map((style, index) => (
          <div className="shadow-2 p-3 border-round-lg" key={index}>
            <Image
              src={getImageUrl(style.singleImage)}
              alt={style.title}
              className="w-full text-center"
              preview
              width="350"
              height="250"
            />
            <p className="text-lg my-3 style-guide-card-title text-center">
              {style.name}
            </p>
          </div>
        ))}
      </div>

      {/* {isOpen && (
        <Lightbox
          mainSrc={getImageUrl(furnishingStyles[currentIndex].singleImage)}
          onCloseRequest={() => setIsOpen(false)}
        />
      )} */}
    </div>
  );
}
